<template>
  <form
    class="sign-in"
    novalidate
    @submit.prevent="send"
  >
    <div
      class="sign-in__field"
      :class="{
        'sign-in__field--error': !isValidEmail && isDirtyField('userEmail'),
      }"
    >
      <label for="userEmail"> E-mail </label>
      <input
        id="userEmail"
        v-model.trim="email"
        name="userEmail"
        type="email"
        @blur="setDirty('userEmail')"
        @focus="removeError('userEmail')"
      />
      <transition name="fade">
        <p
          v-show="!isValidEmail && isDirtyField('userEmail')"
          class="sign-in__field--warning"
        >
          E-mail inválido.
        </p>
      </transition>
    </div>

    <div
      class="sign-in__field"
      :class="{
        'sign-in__field--error':
          !isValidPassword && isDirtyField('userPassword'),
      }"
    >
      <div>
        <label for="userPassword"> Senha </label>
        <input
          id="userPassword"
          v-model="password"
          name="userPassword"
          :type="passwordVisible ? 'text' : 'password'"
          @blur="setDirty('userPassword')"
          @focus="removeError('userPassword')"
        />
        <button
          class="show-password"
          type="button"
          @click.prevent="() => (passwordVisible = !passwordVisible)"
        >
          <IconEye v-if="!passwordVisible" />
          <IconEyeClosed v-else />
        </button>
      </div>
      <transition name="fade">
        <p
          v-if="!isValidPassword && isDirtyField('userPassword')"
          class="sign-in__field--warning"
        >
          Senha inválida.
        </p>
      </transition>
    </div>

    <div class="sign-in__field">
      <button
        class="sign-in__cta"
        :class="{
          'sign-in__cta--disabled': !isValidFields || loading,
          'sign-in__cta--loading': loading,
        }"
        :disabled="!isValidFields || loading"
        type="submit"
      >
        <span>
          {{ loading ? 'Acessando' : 'Acessar' }}
        </span>
      </button>
      <transition name="fade">
        <p
          v-if="submitError"
          class="sign-in__field--warning"
        >
          {{ submitError }}
        </p>
      </transition>
    </div>

    <div class="sign-in__recovery">
      <button @click="$emit('handleFlow', 'request')">
        Esqueci minha senha
      </button>
    </div>
  </form>
</template>

<script>
import IconEye from '@/components/icons/IconEye.vue';
import IconEyeClosed from '@/components/icons/IconEyeClosed.vue';
import emailValidator from '@/validation/validators/email';
import passwordValidator from '@/validation/validators/password';
import errosLogin from '@/helpers/errorsLogin';

export default {
  name: 'SignIn',
  components: {
    IconEye,
    IconEyeClosed,
  },
  data() {
    return {
      email: '',
      password: '',
      passwordVisible: false,
      submitError: '',
      loading: false,
      dirtyFields: [],
    };
  },
  computed: {
    isValidEmail() {
      return emailValidator(this.email);
    },
    isValidPassword() {
      return passwordValidator(this.password);
    },
    isValidFields() {
      return this.isValidEmail && this.isValidPassword;
    },
  },

  methods: {
    setDirty(field) {
      if (!this.dirtyFields.includes(field)) {
        this.dirtyFields.push(field);
      }
    },
    isDirtyField(field) {
      return this.dirtyFields.includes(field);
    },
    removeError(field) {
      this.submitError = '';

      this.dirtyFields = this.dirtyFields.filter((item) => {
        return field !== item;
      });
    },
    send() {
      this.loading = true;

      const { customer } = this.$route.query;
      const userBody = {
        email: this.email,
        password: this.password,
      };

      if (customer) {
        userBody.customer = customer;
      }

      this.$store
        .dispatch('signIn', userBody)
        .then((global) => {
          if (global && !customer) {
            // force refresh to load GTM
            window.location.href = `${window.location.origin}/admin`;
            return;
          }

          window.location.href = `${window.location.origin}/`;
        })
        .catch((err) => {
          const error = err.response?.data;

          this.loading = false;
          this.submitError = errosLogin(error.message, error.remainingAttempts);

          if (error.message === 'Password expired') {
            setTimeout(() => {
              this.$emit('handleFlow', 'request');
            }, 2000);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
